export default __webpack_public_path__ + "static/carousel-16-8c154ba69d46fc64edaa2daae34ec72c.jpg";